/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Edit_Dialog_TitleInputs */

const en_clients_edit_dialog_title = /** @type {(inputs: Clients_Edit_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Client`)
};

const pt_br2_clients_edit_dialog_title = /** @type {(inputs: Clients_Edit_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar Cliente`)
};

/**
* | output |
* | --- |
* | "Edit Client" |
*
* @param {Clients_Edit_Dialog_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_edit_dialog_title = /** @type {((inputs?: Clients_Edit_Dialog_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Edit_Dialog_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_edit_dialog_title(inputs)
	return pt_br2_clients_edit_dialog_title(inputs)
});